import  { combineReducers } from 'redux';
import {installmentReducer} from"./installmentReducer"
import authReducer from "./authReducer"
const rootReducer = combineReducers({
     installmentReducer,authReducer
})
export default rootReducer
